//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { httpAction, getAction } from '@/api/manage';
import JDate from '@/components/jeecg/JDate.vue';
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep';
export default {
  name: "SysUserAgentModal",
  components: {
    JDate: JDate,
    JSelectUserByDep: JSelectUserByDep
  },
  data: function data() {
    return {
      title: "操作",
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      username: "",
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        agentUserName: {
          rules: [{
            required: true,
            message: '请输入代理人用户名!'
          }]
        },
        startTime: {
          rules: [{
            required: true,
            message: '请输入代理开始时间!'
          }]
        },
        endTime: {
          rules: [{
            required: true,
            message: '请输入代理结束时间!'
          }]
        }
      },
      url: {
        add: "/system/sysUserAgent/add",
        edit: "/system/sysUserAgent/edit",
        queryByUserName: "/system/sysUserAgent/queryByUserName"
      }
    };
  },
  created: function created() {},
  methods: {
    agentSettings: function agentSettings(username) {
      this.username = username;
      this.init();
    },
    init: function init() {
      var _this = this;

      var params = {
        userName: this.username
      }; //查询条件

      getAction(this.url.queryByUserName, params).then(function (res) {
        if (res.success) {
          console.log("获取流程节点信息", res);

          _this.edit(res.result);
        } else {
          _this.edit({
            userName: _this.username,
            status: "0"
          });
        }
      });
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this2.form.setFieldsValue(pick(_this2.model, 'userName', 'agentUserName', 'status', 'startTime', 'endTime'));
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this3 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this3.model.id) {
            httpurl += _this3.url.add;
            method = 'post';
          } else {
            httpurl += _this3.url.edit;
            method = 'put';
          }

          var formData = Object.assign(_this3.model, values);
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              }); //this.init();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};